import { validateUnitNumber } from '@planning/rt-stores/helpers'
import { FieldStore, ISubFormStore, required, validateSubForm } from '@tom-ui/utils'
import { makeObservable } from 'mobx'

export type TrailerCreationFormData = {
  iluCode: string
  operator: string
  length: string
  type: string
  plateNumber: string
}

export class TrailerCreationFormStore implements ISubFormStore<TrailerCreationFormData> {
  iluCode: FieldStore<string>
  operator: FieldStore<string>
  length: FieldStore<string>
  type: FieldStore<string>
  plateNumber: FieldStore<string>

  constructor(initialValues?: Partial<TrailerCreationFormData>) {
    makeObservable(this)

    this.iluCode = new FieldStore(initialValues?.iluCode ?? '', this.requiredAndValidUnit)
    this.operator = new FieldStore(initialValues?.operator ?? '', required())
    this.length = new FieldStore(initialValues?.length ?? '')
    this.type = new FieldStore(initialValues?.type ?? '')
    this.plateNumber = new FieldStore(initialValues?.plateNumber ?? '')
  }

  validate = () => validateSubForm(this)

  get data(): TrailerCreationFormData {
    return {
      iluCode: this.iluCode.value,
      operator: this.operator.value,
      length: this.length.value,
      type: this.type.value,
      plateNumber: this.plateNumber.value,
    }
  }

  requiredAndValidUnit = (val?: string): string | undefined => {
    if (val === null || val === '' || val === undefined) {
      return 'fieldIsRequired'
    }
    if (!validateUnitNumber(val)) {
      return 'invalidUnitNumber'
    }
    return undefined
  }
}
